import Modal from "./modal";
import MergeComplainsModal from "./mergeComplainsModal";

export {
    Modal,
    MergeComplainsModal,
}